import { useConditionalEffect, usePrevious } from 'react-delta';

import { Query } from 'common/graphqlTypes';
import { useSetDetailsData } from 'sdk';

export const useDataManager = (detailsData?: Partial<Query>) => {
  const setDetailsData = useSetDetailsData();
  const prevDetailsData = usePrevious(detailsData);

  useConditionalEffect(() => {
    setDetailsData(detailsData);
  }, detailsData !== prevDetailsData);
};
